import React from 'react';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { TimePicker } from '@mui/x-date-pickers';

import { Dayjs } from 'dayjs';

interface LocalisedTimePickerProps {
  label: string;
  time: Dayjs | null; // You can replace 'any' with the appropriate type for 'time'
  setTime: (date: any) => void; // You can replace 'any' with the appropriate type for 'date'
}

const LocalisedTimePicker: React.FC<LocalisedTimePickerProps> = ({
  label,
  time,
  setTime,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en'}>
      <TimePicker
        label={label}
        value={time}
        onChange={(date) => setTime(date)}
        slotProps={{ textField: { size: 'small' } }}
      />
    </LocalizationProvider>
  );
};

export default LocalisedTimePicker;
